import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import momentsClient, { MomentKlydoSelection } from "../../../../api/moments";

const MOMENT_SETTINGS_QUERY_KEY = ["moment-settings"];

export const useMomentSettingsQuery = () =>
  useQuery({
    queryKey: MOMENT_SETTINGS_QUERY_KEY,
    queryFn: () => momentsClient.getSettings(),
  });

export const useUploadMomentCoverMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file: string) => momentsClient.uploadCover(file),
    onSuccess: (settings) =>
      queryClient.setQueryData(MOMENT_SETTINGS_QUERY_KEY, settings),
  });
};

export const useClearMomentCoverMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => momentsClient.clearCover(),
    onSuccess: (settings) =>
      queryClient.setQueryData(MOMENT_SETTINGS_QUERY_KEY, settings),
  });
};

export const useSetKlydoSelectionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (mode: MomentKlydoSelection) =>
      momentsClient.setKlydoSelection(mode),
    onSuccess: (settings) =>
      queryClient.setQueryData(MOMENT_SETTINGS_QUERY_KEY, settings),
  });
};
